import { UI_TAGS } from "@/presentation/helpers/uiTags.js";

export function createTeamSelectBtn(k, x, y, team, onClickCallback) {
    const teamColor = team.color;

    // The main clickable Sheep Actor
    const btn = k.add([
        k.sprite("sheep", { anim: "idle", flipX: true }),
        k.pos(x, y),
        k.anchor("center"),
        k.area(), // Automatically sizes to the sprite
        k.scale(0.8), // Make it a bit bigger for the menu
        k.color(teamColor.r, teamColor.g, teamColor.b),
        k.z(2),
        UI_TAGS.SELECT_TEAM_BUTTON
    ]);

    let isAnimating = false;

    // Hover Effects
    btn.onHover(() => {
        if (!isAnimating) btn.scaleTo(0.9);
    });

    btn.onHoverEnd(() => {
        if (!isAnimating) btn.scaleTo(0.8);
    });

    // The Click "Poke" logic
    btn.onClick(() => {
        if (isAnimating) return;
        isAnimating = true;

        k.play("sheep", { volume: 0.5 });

        const startY = btn.pos.y;

        // The jump animation
        k.tween(0, Math.PI, 0.25, (t) => {
            // KAPLAY V4 STRICT: Re-assign the vector
            btn.pos = k.vec2(btn.pos.x, startY - (Math.sin(t) * 30));
        }, k.easings.linear).onEnd(() => {
            // Snap back to exact floor position
            btn.pos = k.vec2(btn.pos.x, startY);
            onClickCallback();
        });
    });

    return btn;
}